import httpBase from "../utils/http.utils";

export const registerTenantsApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post("/tenants/register", params);
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
}

export const verifyTenantApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post("/tenants/verify", params);
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
}

export const resendVerificationApi = ({
  params,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    try {
      const response = await httpBase().post("/tenants/resend-verification", params);
      successCallback(response?.data);
    }
    catch (e) {
      failureCallback(e);
    }
    finally {
      finalCallback();
    }
  };
}
